var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 3V6.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 3V6.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4167 11.125V17.5375C25.3042 16.65 23.8917 16.125 22.3542 16.125C20.8167 16.125 19.3792 16.6625 18.2542 17.575C16.7417 18.7625 15.7917 20.625 15.7917 22.6875C15.7917 23.9125 16.1417 25.0875 16.7417 26.0625C17.2042 26.825 17.8041 27.4875 18.5166 28H10.1667C5.79166 28 3.91666 25.5 3.91666 21.75V11.125C3.91666 7.375 5.79166 4.875 10.1667 4.875H20.1667C24.5417 4.875 26.4167 7.375 26.4167 11.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.91666 14.25H16.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.91666 20.5H12.1917",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 22.6875C28.9167 23.9125 28.5666 25.0875 27.9666 26.0625C27.6166 26.6625 27.1792 27.1875 26.6667 27.6125C25.5167 28.6375 24.0167 29.25 22.3542 29.25C20.9167 29.25 19.5916 28.7875 18.5166 28C17.8041 27.4875 17.2042 26.825 16.7417 26.0625C16.1417 25.0875 15.7917 23.9125 15.7917 22.6875C15.7917 20.625 16.7417 18.7625 18.2542 17.575C19.3792 16.6625 20.8167 16.125 22.3542 16.125C23.8917 16.125 25.3042 16.65 26.4167 17.5375C27.9417 18.7375 28.9167 20.6 28.9167 22.6875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3542 25.8125C22.3542 24.0875 23.7542 22.6875 25.4792 22.6875C23.7542 22.6875 22.3542 21.2875 22.3542 19.5625C22.3542 21.2875 20.9542 22.6875 19.2292 22.6875C20.9542 22.6875 22.3542 24.0875 22.3542 25.8125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteFavorite);
export default __webpack_public_path__ + "static/media/note-favorite.dd7e37a2e51972466ea4063cad9c9411.svg";
export { ForwardRef as ReactComponent };